import { Fragment } from "react";

import { Button } from "@mui/material";

import { GridItem, GridRow } from "commons/ui/Grid";

import CmNewsForm from "components/form/CmNewsForm";

import { SaveContextProvider } from "context/save";

import useCmNewsForm from "hooks/form/useCmNewsForm";
import useSaveUpdateWithSnackbar from "hooks/useSaveUpdateWithSnackbar";

function ButtonSave() {
    const { onButtonClick } = useSaveUpdateWithSnackbar({
        successMsg: "Notizia aggiornata con successo",
        errorMsg: "Errore nell'aggiornamento della notizia",
        navigateTo: { link: "/cm-notizie" },
    });

    return (
        <GridRow justifyContent={"right"}>
            <GridItem className={"button-under-paper"}>
                <Button variant={"contained"} onClick={onButtonClick}>
                    Salva
                </Button>
            </GridItem>
        </GridRow>
    );
}

function ModificaCmNotiziaInner() {
    const formNewsHook = useCmNewsForm();

    return (
        <>
            <CmNewsForm formNewsHook={formNewsHook} />
            <ButtonSave />
        </>
    );
}

function ModificaCmNotizia() {
    return (
        <Fragment>
            <GridRow className={"title-top-paper"}>
                <GridItem>
                    <h1>Modifica Notizia</h1>
                </GridItem>
            </GridRow>

            <SaveContextProvider>
                <ModificaCmNotiziaInner />
            </SaveContextProvider>
        </Fragment>
    );
}

export default ModificaCmNotizia;
